<mat-accordion multi togglePosition="before" class="asset-area w-full">
  <div class="related-assets-group mb-1">
    <mat-expansion-panel [expanded]="expanded" class="!mb-2" #matExpansionPanel>
      <mat-expansion-panel-header collapsedHeight="2.5rem" expandedHeight="2.5rem">
        <mat-panel-title class="text-2xl"
          ><span class="title-prefix" i18n>Buyout rights:</span>&nbsp;<span class="title-suffix">{{ formValue.buyoutRightsTitle.name }}</span></mat-panel-title
        >
        <ng-container *ngIf="callFrom === 'assetUpload'">
          <ng-container
            *ngTemplateOutlet="
              actionButton;
              context: {
                $implicit: { edit: true, delete: true },
              }
            "
          ></ng-container>
        </ng-container>
      </mat-expansion-panel-header>
      <div class="w-full formField-viewer py-4">
        @if (formValue.buyoutRightsSecondLevelType) {
          @for (buyoutRight of $any(formValue.buyoutRightsSecondLevelType | keyvalue); track buyoutRight.key; let i = $index) {
            <div class="section mx-2" [ngClass]="{ 'mt-3 border-t-2 pt-3': i !== 0 }">
              <h3 class="text-xl font-semibold mb-4">{{ buyoutRight.value | optionsLabel: BuyoutRightsMakeOSSecondLevel }}</h3>
              <div class="general-info-details">
                @for (buyoutRightsConfig of buyoutRightsConfigs[(buyoutRight.value | keyValueUtil: 'value').toLowerCase()]; track buyoutRightsConfig.fieldLabel) {
                  @if (formValue.buyoutRightsFormArray[+(buyoutRight.key | keyValueUtil: 'value')][buyoutRightsConfig.formFieldName]) {
                    <ng-container
                      *ngTemplateOutlet="buyoutRightsField; context: { config: buyoutRightsConfig, data: formValue.buyoutRightsFormArray[+(buyoutRight.key | keyValueUtil: 'value')] }"
                    ></ng-container>
                  }
                }
              </div>
              <ng-container
                *ngTemplateOutlet="tableTemplate; context: { territories: formValue.buyoutRightsFormArray[+(buyoutRight.key | keyValueUtil: 'value')]['territoriesFormArray'] }"
              ></ng-container>
            </div>
          }
        } @else {
          @for (buyoutRight of formValue.buyoutRightsFormArray; let i = $index; track i) {
            <div class="section mx-2" [ngClass]="{ 'mt-3 border-t-2 pt-3': i !== 0 }">
              <h3 class="text-xl font-semibold mb-4">{{ formValue.buyoutRightsTitle.name }} {{ formValue.buyoutRightsTitle.name === 'Cast' ? 'member' : '' }} #{{ i + 1 }}</h3>
              <div class="general-info-details">
                @for (buyoutRightsConfig of buyoutRightsConfigs[formValue.buyoutRightsTitle._id]; track buyoutRightsConfig.fieldLabel) {
                  <ng-container *ngTemplateOutlet="buyoutRightsField; context: { config: buyoutRightsConfig, data: buyoutRight }"></ng-container>
                }
              </div>
              <ng-container *ngTemplateOutlet="tableTemplate; context: { territories: buyoutRight['territoriesFormArray'] }"></ng-container>
            </div>
          }
        }
      </div>
    </mat-expansion-panel>
  </div>
</mat-accordion>

<ng-template #tableTemplate let-territories="territories">
  <div class="table border-separate border-spacing-y-2 w-full" *ngIf="columns.length > 0">
    <div class="table-header-group font-bold">
      <ng-container *ngFor="let col of columns">
        <div class="table-cell px-3" [ngClass]="col['class']">
          @if (col['columnDef'] === 'media') {
            {{ col.header }}
            <mat-icon
              class="text-[#1212128F] text-[1.4rem] cursor-pointer align-bottom"
              i18n-matTooltip
              [matTooltip]="'For more info about the exact scope please check in edit mode or contact your support.'"
              >info</mat-icon
            >
          } @else {
            {{ col.header }}
          }
        </div>
      </ng-container>
    </div>
    <div class="table-row-group">
      <ng-container *ngFor="let territory of territories; let i = index">
        <div class="table-row shadow-[0_3px_10px_rgb(0,0,0,0.2)] rounded-lg" [ngClass]="{ 'bg-[#f5dfd8]': !(territory.expiryDate | dateNotExpired) }">
          <ng-container *ngFor="let col of columns">
            <div class="table-cell p-3" *ngIf="col['columnDef'] === 'territory' || col['columnDef'] === 'media'; else renderOtherColumns">
              <ng-container *ngIf="buyoutUtilsService.mediaAndTerritoryFormatting(territory[col['columnDef']], col) as formattedData">
                <div *ngFor="let data of formattedData">
                  {{ data.finalSelectedValuesArray | optionsLabel: col['options'] }}
                  <ng-container *ngIf="data.finalExcludedValues.length > 0"> (excl. {{ data.finalExcludedValues | optionsLabel: col['options'] }})</ng-container>
                </div>
              </ng-container>
              <ng-container *ngIf="buyoutUtilsService.independentSelectedMediaAndTerritoryFormatting(territory[col['columnDef']], col) as formattedData">
                <ng-container *ngFor="let data of formattedData; let last = last"> {{ data | optionsLabel: col['options'] }}<span *ngIf="!last">, </span> </ng-container>
              </ng-container>
            </div>
            <ng-template #renderOtherColumns>
              <div class="table-cell p-3" [ngClass]="{ 'text-[#bf360c]': col.columnDef === 'expiryDate' && !(territory[col['columnDef']] | dateNotExpired) }">
                {{ territory[col['columnDef']] ?? dateMultiEditText[i] | keyValueUtil: 'value' : undefined : col['columnDef'] }}
              </div>
            </ng-template>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #buyoutRightsField let-config="config" let-data="data">
  <ng-container *ngIf="config.fieldType !== 'checkbox' && data[config.formFieldName]">
    <div class="general-info-details-entry">
      <h4 class="general-info-details-label">{{ config.fieldLabel }}</h4>
      <div class="general-info-details-value" *ngIf="config.fieldType === 'text'">
        {{ data[config.formFieldName] }}
      </div>
      <div class="general-info-details-value" *ngIf="config.fieldType === 'textarea'" [innerHTML]="data[config.formFieldName]"></div>
    </div>
  </ng-container>
  <div class="checkbox-specific" *ngIf="config.fieldType === 'checkbox' && data[config.formFieldName]">
    <mat-checkbox class="w-full" disabled [checked]="data[config.formFieldName]"></mat-checkbox>
    <div class="general-info-details-label">{{ config.fieldLabel }}</div>
  </div>
</ng-template>

<ng-template #actionButton let-buttonsVisibility let-usageRightObj="usageRightObj" let-type="type" let-index="index">
  <div>
    <button
      *ngIf="buttonsVisibility.edit"
      (click)="editBuyoutRights.emit(); matExpansionPanel.close(); $event.stopPropagation()"
      class="icon-button-narrow cursor-pointer"
      mat-icon-button
      role="button"
      i18n-matTooltip
      matTooltip="Edit buyout rights"
    >
      <mat-icon class="material-icons-outlined">edit</mat-icon>
    </button>
    <button
      *ngIf="buttonsVisibility.delete"
      (click)="deleteBuyoutRights.emit(); $event.stopPropagation()"
      class="icon-button-narrow cursor-pointer"
      mat-icon-button
      role="button"
      i18n-matTooltip
      matTooltip="Delete buyout rights"
    >
      <mat-icon class="material-icons-outlined">delete</mat-icon>
    </button>
  </div>
</ng-template>
